@import "~@govbr-ds/core/src/partial/scss/base";

:host {
  display: block;
  position: relative;

  #trigger {
    display: inline-block;
    cursor: pointer;
    outline: none;
  }

  #trigger::slotted([slot="trigger"]) {
    &:focus {
      @include focus;
    }
  }

  ::slotted([slot="target"] *:focus) {
    @include focus;
  }

  #target {
    display: none;
    position: absolute;
    /* Garante que o conteúdo do dropdown fique acima do trigger/botões ao redor */
    box-shadow: var(--surface-shadow-sm);
    z-index: var(--z-index-layer-1);

    &:focus {
      @include focus;
    }
  }
}

:host([is-open]) {
  #target {
    display: block;
    width: max-content;
  }
}

@include media-breakpoint-down(xs) {
  :host([is-open]) {
    #target {
      width: 100vw !important;
      max-width: 100vw !important;
    }
  }
}
